import axios from "axios";
import authHeader from "../Components/Auth/Autenticacao/services/auth-header"

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: authHeader()
});

export default api;